import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ContentLoader from '../Loader/ContentLoader';

const NavigationWrapper: React.FC = () => {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    // Show navigation loader when route changes
    setIsNavigating(true);

    // Hide loader after 1s to cover both navigation and initial API loading
    const timer = setTimeout(() => {
      setIsNavigating(false);
    }, 1000); // 1 second delay to cover navigation + API loading

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Show local navigation loader during route changes */}
      {isNavigating && (
        <ContentLoader 
          text="Loading page..." 
          variant="minimal" 
          size="medium"
        />
      )}
      {/* Always render the outlet, loader will overlay if needed */}
      <Outlet />
    </div>
  );
};

export default NavigationWrapper;